import { Badge } from "@/components/ui/badge"
import { OrderStatus } from "@/api/api-client"
import { cn } from "@/lib/utils"

import { getOrderStatusPresentation, type OrderStatusLabels } from "./order-status-presentation"

interface OrderStatusBadgeProps {
  status: OrderStatus
  labels?: OrderStatusLabels
  label?: string
  className?: string
}

export function OrderStatusBadge({ status, labels, label, className }: OrderStatusBadgeProps) {
  const presentation = getOrderStatusPresentation(status, labels)

  return (
    <Badge
      variant="outline"
      className={cn(
        "text-xs font-bold uppercase tracking-wider",
        presentation.badgeClassName,
        className
      )}
    >
      {label ?? presentation.label}
    </Badge>
  )
}
